import { Calendar } from "lucide-react"
import { SleepCellBase } from "./SleepCellBase"
import { formatDbTimestampToLocal } from "@/lib/utils/date"

interface SleepDateCellProps {
  startTime: string | null
  timezone?: string
}

export function SleepDateCell({ startTime, timezone }: SleepDateCellProps) {
  return (
    <SleepCellBase icon={Calendar} iconColor="text-purple-400">
      {startTime ? formatDbTimestampToLocal(startTime, "MMM DD, YYYY") : "TBD"}
    </SleepCellBase>
  )
}
